module.exports = __webpack_public_path__ + "img/logo_3d.1ff12c60.png";